import styled from 'styled-components';

export const LinkButtonWrapper = styled.span`
  text-decoration: underline;
  cursor: pointer;
  color: ${({ theme }) => theme.colours.interface.strong};
  display: inline-block;
  font-weight: 100;

  &:hover {
    color: ${({ theme }) => theme.colours.interface.strong};
    text-decoration: underline;
  }

  &:focus,
  &:active {
    outline: none;
    background: none;
  }

  button {
    color: ${({ theme }) => theme.colours.interface.strong};
    font-size: ${({ theme }) => theme.typography.bodyMedium.fontSize};
    padding: 0;
    border: 0;
    margin-top: -2px;

    &:hover {
      color: ${({ theme }) => theme.colours.interface.strong} !important;
      text-decoration: none;
    }

    &:active {
      background: none !important;
    }
  }
`;
